import React from "react";
import smallCross from "@imgs/front_office/shared/small_cross.svg";
import smallCheckmark from "@imgs/front_office/shared/small_checkmark.svg";
import translator from "@/translator";
const t = translator("front_office.views.payments.tariff.");

const Tariff = ({ tariff_title, has_any_problems, tariff_rate }) => {
  return (
    <div className="tariff">
      <div className="tariff-title">
        {t("your_tariff")} {tariff_rate && <div className="tariff-label">{tariff_rate}</div>}
      </div>
      <div className="tariff-sub_title">
        <img src={has_any_problems ? smallCross : smallCheckmark} /> {tariff_title}
      </div>
    </div>
  );
};

export default Tariff;
